
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'InvoiceHeader'
})
export default class extends Vue {
  @Prop({ required: true }) title!: string
}
